/**
 * Toast hook — thin wrapper over notistack v3.
 *
 * Enqueues an MUI Alert inside a Snackbar. Auto-hide durations:
 *   success/info: 4s, warning/error: 6s (per product-output.md).
 */
import { useSnackbar, type VariantType } from 'notistack';
import { useCallback } from 'react';

type Severity = 'success' | 'info' | 'warning' | 'error';

const AUTO_HIDE_MS: Record<Severity, number> = {
  success: 4000,
  info: 4000,
  warning: 6000,
  error: 6000,
};

export function useToast() {
  const { enqueueSnackbar } = useSnackbar();

  const toast = useCallback(
    (message: string, severity: Severity = 'success') => {
      enqueueSnackbar(message, {
        variant: severity as VariantType,
        autoHideDuration: AUTO_HIDE_MS[severity],
      });
    },
    [enqueueSnackbar],
  );

  return { toast };
}
